import { Box, IconButton } from '@mui/material';
import cx from 'clsx';

import styles from './Hamburger.module.scss';

interface HamburgerProps {
  open: boolean;
  onToggle: () => void;
  classes?: {
    root?: string;
    bar?: string;
  };
}

const Hamburger = ({ open, onToggle, classes }: HamburgerProps) => (
  <IconButton
    classes={classes}
    className={cx(styles.burger, { [styles.active]: open })}
    onClick={onToggle}
    aria-label={open ? 'Close menu' : 'Open menu'}
  >
    <Box className={styles.hamburgerMenu}>
      <Box className={cx(styles.bar, { [styles.open]: open })} />
      <Box className={cx(styles.bar, { [styles.open]: open })} />
      <Box className={cx(styles.bar, { [styles.open]: open })} />
    </Box>
  </IconButton>
);

export default Hamburger;
